import React from 'react'
import { Button, CircularProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  buttonProgress: {
    marginRight: '10px'
  },
  button: {
    borderRadius: '8px',
    fontWeight: 500,
    padding: '10px 20px',
    textTransform: 'none',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 10px rgba(21, 180, 219, 0.2)',
    '&:hover': {
      boxShadow: '0 6px 14px rgba(21, 180, 219, 0.3)'
    }
  }
})

const ProgressButton = ({ label, inProgress, className, ...rest }) => {
  const classes = useStyles()

  return (
    <div className={classes.buttonWrapper}>
      <Button
        startIcon={
          inProgress && (
            <CircularProgress color="secondary" size={18} className={classes.buttonProgress} />
          )
        }
        variant="contained"
        size="large"
        color="primary"
        className={`${classes.button} ${className || ''}`}
        {...rest}>
        {label}
      </Button>
    </div>
  )
}

export default ProgressButton
